import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import Label from '../../label/Label';
import './alarmData.scss';
import PropTypes from 'prop-types';

const AlarmData = ({
	activeAlarmCritical,
	activeAlarmMajor,
	activeAlarmMinor,
	criticalCount,
	majorCount,
	minorCount,
}) => {
	const tabs = [
		{ label: 'Critical', id: 'critical', count: criticalCount },
		{ label: 'Major', id: 'major', count: majorCount },
		{ label: 'Minor', id: 'minor', count: minorCount },
	];
	// const [criticalLength, setCriticalLength] = useState(0);
	// const [majorLength, setMajorLength] = useState(0);
	// const [minorLength, setMinorLength] = useState(0);
	const [selectedMenu, setSelectedMenu] = useState('critical');
	const [filteredAlarm, setFilteredAlarm] = useState([]);

	const onClickMenu = (menuName) => {
		setSelectedMenu(menuName);
		onChangeMenuItem(menuName);
	};

	const onChangeMenuItem = (item) => {
		console.log('onChangeMenuItem', item);
	};

	useEffect(() => {
		if (selectedMenu === 'critical') {
			setFilteredAlarm(
				activeAlarmCritical.length > 0
					? activeAlarmCritical
					: []
			);
			
		} else if (selectedMenu === 'major') {
			setFilteredAlarm(
				activeAlarmMajor.length > 0
					? activeAlarmMajor
					: []
			);
		} else if (selectedMenu === 'minor') {
			setFilteredAlarm(
				activeAlarmMinor.length > 0
					? activeAlarmMinor
					: []
			);
		}
	}, [selectedMenu, activeAlarmCritical, activeAlarmMajor, activeAlarmMinor]);


	useEffect(() => {
		setFilteredAlarm(activeAlarmCritical);
	}, []);
	const defaultLabel = (selectedMenu) => {
		if(selectedMenu === 'major'){
			return 'No Major Alarm'
		}
		else if(selectedMenu === 'minor'){
			return 'No Minor Alarm'
		}
		else {
			return 'No Critical Alarm'
		}
	}
	console.log('filter------ ', criticalCount,majorCount,minorCount,tabs);
	return (
		<div>
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<div>
						<Box className={'alarm-headerContainerRow'}>
							<Box className={'system-row_one'}>
								{tabs.map((item, index) => (
									<Box
										key={item.id}
										onClick={() => onClickMenu(item.id)}
										className={
											index > 0
												? ' alarm-rowPadding2'
												: ' alarm-rowPadding1'
										}
										sx={{overflow:'hidden'}}
									>
										<Label
											type={
												selectedMenu === item.id
													? 'hyperlink'
													: 'secondary'
											}
											
											label={item.label}
											
											style={{
												height: '15px',
												width: '48px',
												marginLeft: '8px',
												cursor: 'pointer',
												paddingLeft:'4px',
											}}
											fontSize={'x_small'}
											fontFamily={'Inter-semiBold'}
										/>
										<Label
											type={
												selectedMenu === item.id
													? 'hyperlink'
													: 'secondary'
											}
											
											label={`(${item.count})`}
											
											style={{
												height: '15px',
												width: '48px',
												marginLeft: '2px',
												cursor: 'pointer',
												paddingRight:'4px',
											}}
											fontSize={'x_small'}
											fontFamily={'Inter-semiBold'}
										/>
										<div
											style={{
												paddingTop: '5px',
												marginLeft: '8px',
											}}
										>
											<hr
												className={
													selectedMenu === item.id
														? 'alarm-selected_bar'
														: 'alarm-unselected_bar'
												}
											/>
										</div>
									</Box>
								))}
							</Box>
						</Box>
					</div>
					<Grid className="alarm-body">
						{filteredAlarm.map((val) => {
							return (
								<div key={val.key} className="alarm-content">
									<Label
										type = {'primary'}
										fontSize={'x_small'}
										fontFamily = {'Inter-Regular'}
										label={val.value}
										style={{textOverflow:'ellipsis', overflow:'hidden'}}
									/>
								</div>
							);
						})}
						{
							filteredAlarm.length === 0 && 
								<Box className = {'empty-view'}>
									<Label
										type = {'disabled'}
										fontSize={'x_small'}
										fontFamily = {'Inter-Regular'}
										label={defaultLabel(selectedMenu)}
									/>
								</Box>
						}
					</Grid>
				</div>
			</div>
		</div>
	);
};

AlarmData.propTypes = {
	activeAlarmCritical: PropTypes.array.isRequired,
	activeAlarmMajor: PropTypes.array.isRequired,
	activeAlarmMinor: PropTypes.array.isRequired,
	criticalCount: PropTypes.string.isRequired,
	majorCount: PropTypes.string.isRequired,
	minorCount: PropTypes.string.isRequired,
};

export default AlarmData;
